import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React, { useState } from 'react';
// import VisionImg from "../assets/32.svg"
// import VisionImg from "../assets/33.png"
import VisionImg from "../assets/images/product/cabin-vision.png";
import ViewImg from "../assets/images/product/roadsense.png";
import SenseImg from "../assets/images/product/sense.png";
import HappyImg from "../assets/images/product/happy.webp";
import EyeImg from "../assets/images/product/Eye.webp";
import CallImg from "../assets/images/product/LifeSavers.png";
import BusImg from "../assets/images/product/bus.webp";
import { Link } from 'react-router-dom';
import ProductSlider from './Product/ProductSlider';
import CardSlider2Video from './Slider/CardSlider2Video';

gsap.registerPlugin(ScrollTrigger);

const cabinalertsfeatures = [
    {
        id: 1,
        category: "DSM-Alert",
        title: "Smoking Warning",
        description: "Smoking Warning alerts drivers when Shoora's DSM Camera detects drivers who are smoking, and generates an alert promoting a safer and distraction-free driving environment.",
        image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
        type: "video",
        videoSrc: "/videos/alerts/smoking-warning.mp4",
        audioSrc: "/audio/alerts/smoking-warning.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 2,
        category: "DSM-Alert",
        title: "Driver Fatigue Warning",
        description: "Driver Fatigue alert detects drowsiness using Shoora's AI-enabled DSM Camera, warning drivers to stay alert and prevent accidents.",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
         type: "video",
         videoSrc: "/videos/alerts/fatigue-warning.mp4",
         audioSrc: "/audio/alerts/fatigue-warning.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 3,
        category: "DSM-Alert",
        title: "Mobile Usage Alert",
        description: "Mobile Usage Warning alerts drivers when Shoora's DSM Camera detects phone use, reducing distractions and promoting safer driving habits.",
        image: "https://images.pexels.com/photos/19157992/pexels-photo-19157992.jpeg?auto=compress&cs=tinysrgb&w=600",
        type: "video",
        videoSrc: "/videos/alerts/mobile-usage-warning.mp4",
        audioSrc: "/audio/alerts/mobile-usage-warning.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 4,
        category: "DSM-Alert",
        title: "Distracted Driving Alert",
        description: "Distraction alert detects driver inattention using Shoora DSM Camera, ensuring safety by identifying gaze deviation.",
        image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
        type: "video",
        videoSrc: "/videos/alerts/distracted-driving.mp4",
        audioSrc: "/audio/alerts/distracted-driving.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 5,
        category: "DSM-Alert",
        title: "Face Not Detected",
        description: "Face Not Detected alert warns when the Shoora DSM Camera fails to detect the driver’s face, ensuring continuous monitoring and safety.",
        image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
        type: "video",
        videoSrc: "/videos/alerts/face-not-detected.mp4",
        audioSrc: "/audio/alerts/face-not-detected.mp3",
        // link: "#",
        // linkText: "Read more",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 6,
        category: "ADAS-Alert",
        title: "Proximity Alert",
        description: "Proximity Alert warns drivers when Shoora's ADAS Camera detects nearby objects or vehicles, ensuring safe distance and preventing collisions.",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
        type: "video",
        videoSrc: "/videos/alerts/proximity-alert.mp4",
        audioSrc: "/audio/alerts/proximity-alert.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 7,
        category: "ADAS-Alert",
        title: "Forward Collision Warning ",
        description: "Forward Collision Warning alerts drivers when Shoora's ADAS Camera detects a potential frontal collision, enabling timely action to prevent accidents.",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
       type: "video",
       videoSrc: "/videos/alerts/forward-collision-warning.mp4",
        audioSrc: "/audio/alerts/forward-collision-warning.mp3",
        
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 8,
        category: "ADAS-Alert",
        title: "Lane Departure Warning",
        description: "Lane Departure Warning alerts drivers when the Shoora ADAS Camera detects unintentional lane drift, enhancing road safety and preventing accidents",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
       type: "video",
       videoSrc: "/videos/alerts/lane-departure-warning.mp4",
        audioSrc: "/audio/alerts/lane-departure-warning.mp3",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 9,
        category: "ADAS-Alert",
        title: "Harsh Turning Warning",
        description: "Harsh Turning Warning alerts drivers when Shoora's ADAS Camera detects sudden or aggressive turns, promoting safer and more controlled driving.",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
       type: "video",
       videoSrc: "/videos/alerts/harsh-turning-warning.mp4",
        audioSrc: "/audio/alerts/harsh-turning-warning.mp3",
        // link: "#",
        // linkText: "Read more",
        // link: "#",
        // linkText: "Read more",
    },
    {
        id: 10,
        category: "ADAS-Alert",
        title: "Pedestrian Detection",
        description: "Pedestrian Detection alerts drivers when Shoora's ADAS Camera identifies pedestrians nearby, helping prevent collisions and ensuring road safety.",
        image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
       type: "video",
       videoSrc: "/videos/alerts/pedestrian-detection.mp4",
        audioSrc: "/audio/alerts/pedestrian-detection.mp3",
        // 
        // link: "#",
        // linkText: "Read more",
    },

];


const NewFeatures = ({ features }) => {
    const [activeFeature, setActiveFeature] = useState();
    useGSAP(() => {
        gsap.from(".subhead", {
            scrollTrigger: {
                trigger: '.subhead',
                toggleActions: 'restart none none none'
            },
            opacity: 0,
            delay: 0.5,
            duration: 1,
            y: '10px'
        }),
            // Animation and pinning for each feature video
            features.forEach((_, index) => {
                gsap.to(`.feature-video-${index}`, {
                    scrollTrigger: {
                        trigger: `.feature-video-${index}`,
                        start: "top 40%", // Adjust start position
                        end: "bottom top", // Define the end point for the pinning
                        toggleActions: 'restart none none none',
                        pin: true, // Pin the feature-video section
                        pinSpacing: false, // Adjust spacing when pinned
                        scrub: true, // Allow the pinning to follow the scroll
                        // markers: true,
                    },
                    opacity: 0,
                    duration: 2,
                    ease: 'power3.out',
                });
            });
    })
    return (
        <>

            <div className="scroll-feature-section">

                <div className="container-fluid px-0">
                    <div className="feature-static-heading-banner " style={{
                        backgroundImage: "url(https://cdn.pixabay.com/photo/2022/11/25/18/57/traffic-cone-7616718_1280.jpg)",
                        objectFit: "cover", width: "100%", minHeight: "300px"
                    }}>
                        <h3 className='text-light'>
                            {/* Smart Fleet Management  */}
                            Reduce the total cost of ownership and improve the ROI
                            of your <br /> <i>fleet operations</i>
                        </h3>

                    </div>

                    <div className="feature-static-heading ">

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold'>Cab</span><span style={{ color: "var(--accent-color)" }}>In</span>{" "}
                            <span style={{ fontWeight: 300 }}>Alerts</span>
                            <sup style={{ fontWeight: 500, fontSize: "10px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    {/* {features.map((feature, index) => (
                        <div
                            key={index}
                            //   ref={(el) => (sectionRefs.current[index] = el)}
                            className={`feature-section mb-4 ${index === activeFeature ? "active" : ""
                                }`}
                        // style={{ backgroundImage: `url(${feature.backgroundImage})` }}
                        >
                            <div className="feature-content">
                                <h3 className="mt-5">
                                    Cab<span style={{ color: "orange" }}>In</span>{" "}
                                    <span style={{ fontWeight: 300 }}>Alerts</span>
                                    <sup style={{ fontWeight: 500, fontSize: "10px", position: "relative", top: "-10px" }}>TM</sup>
                                </h3>

                                <h2>{feature.title}</h2>
                                <p>{feature.description}</p>

                            </div>
                            <div className={`feature-video feature-video-${index}`}>

                                <video
                                    src={feature.videoSrc}
                                    autoPlay
                                    loop
                                    muted={true}
                                    playsInline
                                />

                            </div>
                        </div>
                    ))} */}

                    {/* <ProductSlider/> */}
                    <CardSlider2Video data={cabinalertsfeatures}/>
                    <div className="feature-static-heading " style={{backgroundColor: "var(--gradient-color-1)"}}>

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold'>Cab</span><span style={{ color: "var(--accent-color)" }}>In</span>{" "}
                            <span style={{ fontWeight: 300 }}>Vision</span>
                            <sup style={{ fontWeight: 500, fontSize: "10px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container"  style={{backgroundColor: "var(--gradient-color-1)"}}>
                        <div className="row row-cols-1 row-cols-lg-2" >
                            <div className="col">
                                <img src={VisionImg} alt="" className='w-100' />
                            </div>
                            <div className="col">
                                <h5>
                                    2-Channel and 3-Channel DSM System. Advanced driver monitoring solution that continuously track driver behaviour in real-time. This system ensures proactive safety coaching and trigger instant alerts upon detecting driving anomalies, promoting safer and more responsible driving.
                                </h5>
                                <ul className='row mt-4 ps-0'>
                                    <li className='row'>
                                        <i class="col-2 col-md-1 fa-solid fa-wifi text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className=" col features-text">
                                            <h6>Internet-Connected Dashcams</h6>
                                            <p className='lh-1'
                                                style={{ fontSize: "13px" }}>
                                                Advanced driver-facing AI dash cams with up to 2K (1440p) resolution for crystal-clear monitoring.</p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-road-circle-exclamation text-accent" style={{ fontSize: "33px" }}></i>
                                        <div className="col features-text">
                                            <h6>Address Unsafe Driving Habits</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}> Real-time AI technology identifies risky behaviours, including fatigue, distraction, smoking, phone use, yawning, and failure to wear a seatbelt, promoting safer driving.

                                            </p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-circle-play justify-content-center text-accent" style={{ fontSize: "38px" }}></i>
                                        <div className=" col features-text">
                                            <h6>On-Demand Video Access</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Retrieve event footage over the air for instant reconstruction and analysis when needed.</p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class=" col-2 col-md-1  icon fa-solid fa-screwdriver-wrench text-accent" style={{ fontSize: "35px" }}></i>
                                        <div className="col features-text">
                                            <h6>Effortless Setup</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Plug-and-play design ensures your dashcam is up and running in just minutes.</p>
                                        </div>
                                    </li>
                                </ul>
                                <Link to="/solutions/cabin-vision" className='text-decoration-none fs-5 fw-bold text-dark'>{"Explore"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading ">

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold'>Road</span><span style={{ color: "var(--accent-color)" }}>Sense</span>
                           
                            <sup style={{ fontWeight: 500, fontSize: "10px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container">
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5" >

                            <div className="col order-1 order-lg-0">
                                <h5>
                                    Enhance safety and safeguard your fleet with a road facing AI-driven Dash Cam for risk detection and instant video retrieval, ensuring overall accident prevention and vehicle protection when it matters most.
                                </h5>
                                <ul className='row mt-4 ps-0'>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-truck-front text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className=" col features-text">
                                            <h6 className=''>Proximity Alert</h6>
                                            <p className='lh-1'
                                                style={{ fontSize: "13px" }}>
                                                Detects and trains drivers who
                                                follow other vehicles too closely.</p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-car-burst text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className="col features-text">
                                            <h6>Frontal Collision Alert</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Alerts drivers to
                                                potential forward collisions.

                                            </p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-eye justify-content-center text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className=" col features-text">
                                            <h6>Instant Access to Event Video</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Receive
                                                immediate alerts and locate video evidence instantly.</p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class=" col-2 col-md-1  icon fa-solid fa-video text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className="col features-text">
                                            <h6>HD Videos for Clear Visibility</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Get
                                                crystal-clear insights with HD footage.</p>
                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class=" col-2 col-md-1  icon fa-solid fa-comments text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className="col features-text">
                                            <h6>Real-time 2 Way Voice Communication</h6>
                                            <p className='lh-1' style={{ fontSize: "13px" }}>Enables our control room to communicate with drivers in real-time, preventing life-threatening situations and accidents.</p>
                                        </div>
                                    </li>
                                </ul>
                                <Link to="/solutions/road-sense" className='text-decoration-none fs-5 fw-bold text-dark'>{"Explore"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col order-0 order-lg-1">
                                <img src={ViewImg} alt="" className='w-100 mx-auto' />
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading "  style={{backgroundColor: "var(--gradient-color-1)"}}>

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold'>Fleet</span><span className='fw-bold' style={{ color: "var(--accent-color)" }}>Sense</span>

                            <sup style={{ fontWeight: 700, fontSize: "13px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container"  style={{backgroundColor: "var(--gradient-color-1)"}}>
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5" >

                            <div className="col order-1 order-lg-0">
                                <h5>
                                    Stay aware of operations—anytime, anywhere. Receive in-app alerts for critical events, and
                                    access real-time vehicle locations, diagnostics, and sensor data, whether you're in the office
                                    or on the road.

                                </h5>
                                <ul className='row mt-4 ps-0 row-gap-4'>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-truck-front text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className=" col features-text">
                                            <h6 className=''>Fleet Management</h6>

                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-gas-pump text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className="col features-text">
                                            <h6>Fuel Management</h6>

                                        </div>
                                    </li>
                                    <li className='row'>
                                        <i class="col-2 col-md-1  fa-solid fa-eye justify-content-center text-accent" style={{ fontSize: "30px" }}></i>
                                        <div className=" col features-text">
                                            <h6>Control Room</h6>

                                        </div>
                                    </li>

                                </ul>
                                <Link to="/solutions/fleet-sense" className='text-decoration-none fs-5 fw-bold text-dark'>{"Discover"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col col-lg-5 order-0 order-lg-1">
                                <img src={SenseImg} alt="" className='w-100' />
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading ">

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold' style={{ color: "var(--accent-color)" }}> Happy Driver</span> <span className='fw-semibold' >Programme</span>

                            <sup style={{ fontWeight: 700, fontSize: "13px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container">
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5" >

                            <div className="col order-1 order-lg-0">
                                <h5 className='text-lora'>
                                    <i>Highly customisable e-modules to train drivers for safety. Enhance training effectiveness
                                        using powerful tools and reward points to promote safer driving and help drivers reinforce
                                        positive driving behaviours.</i>


                                </h5>
                                <p className='mt-5'><b>HDScore</b> tracks driver performance over time, rewarding safe driving behaviour and
                                    reducing the number of alerts generated. Drivers are also rewarded for making real-time
                                    corrections when alerted by CabIn Alerts.
                                </p>
                                <Link to="/solutions/happy-driver-programme" className='text-decoration-none fs-5 fw-bold text-dark'>{"Know More"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col order-0 order-lg-1">
                                <img src={HappyImg} alt="" className='w-100' />
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading "  style={{backgroundColor: "var(--gradient-color-1)"}}>

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold' style={{ color: "var(--accent-color)" }}> Marut</span> <span className='fw-semibold' >Insights</span>

                            <sup style={{ fontWeight: 700, fontSize: "13px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container"  style={{backgroundColor: "var(--gradient-color-1)"}}>
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5 align-items-center" >

                            <div className="col order-1 order-lg-0">
                                <h5 className=' fs-4 mb-5'>
                                    Stand-out as a safety leader. Use powerful insights and predictive decision making to
                                    prioritise safety initiatives, attract top talent, recognize excellence, and safeguard your
                                    bottom line.

                                </h5>

                                <Link to="/solutions/marut-insights" className='text-decoration-none fs-5 fw-bold text-dark'>{"Find it how"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col order-0 order-lg-1 d-flex justify-content-end">
                                <img src={EyeImg} alt="" className='w-100 w-lg-75' />
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading ">

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold' style={{ color: "var(--accent-color)" }}> Shoora</span> <span className='fw-semibold' >Life Savers</span>

                            <sup style={{ fontWeight: 700, fontSize: "13px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container">
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5 align-items-center" >

                            <div className="col order-1 order-lg-0">
                                <h5 className=' fs-4 mb-5'>
                                    A highly trained back-office team complements our SaaS platform, reaching out to drivers
                                    during emergencies and elevating customer service to the next level.

                                </h5>

                                <Link to="/solutions/shoora-life-savers" className='text-decoration-none fs-5 fw-bold text-dark'>{"Know More"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col order-0 order-lg-1 d-flex justify-content-end">
                                <img src={CallImg} alt="" className='w-100 w-lg-75' />
                            </div>
                        </div>
                    </div>
                    <div className="feature-static-heading "  style={{backgroundColor: "var(--gradient-color-1)"}}>

                        <h3 className="mt-5 subhead">
                            <span className='fw-bold' > Connected</span> <span className='fw-semibold' style={{ color: "var(--accent-color)" }} >School Bus</span>

                            <sup style={{ fontWeight: 700, fontSize: "13px", position: "relative", top: "-24px" }}>TM</sup>
                        </h3>
                    </div>
                    <div className="container"  style={{backgroundColor: "var(--gradient-color-1)"}}>
                        <div className="row row-cols-1 row-cols-lg-2 px-lg-5 align-items-center" >

                            <div className="col order-1 order-lg-0">
                                <h5 className=' fs-4 mb-5'>
                                    A groundbreaking innovation in school safety, utilising geofences to notify when a vehicle
                                    enters, exits, or stays within a designated area beyond a set timeframe. Additionally, it
                                    detects student drop-offs through camera-based counts.
                                </h5>

                                <Link to="/coming-soon" className='text-decoration-none fs-5 fw-bold text-dark'>{"Know More"} <i class="fa-solid fa-arrow-up-right-from-square"></i></Link>
                            </div>
                            <div className="col order-0 order-lg-1 d-flex justify-content-end">
                                <img src={BusImg} alt="" className='w-100' />
                            </div>
                        </div>
                    </div>

                    <div className="feature-static-heading-banner " style={{
                        backgroundImage: "url(/images/about/bg10.png)",
                        objectFit: "cover", width: "100%", height: "50vh"
                    }}>
                        <h3 className='text-light wordCarousel'>
                            Stay Alert with Technology Powered by
                            {/* <i className='anim-text-gradient'>Artificial Intelligence</i> */}
                            <div>
                                {/* <!-- Use classes 2,3,4, or 5 to match the number of words --> */}
                                <ul class="flip5">
                                    <li><i className='anim-text-gradient'>Artificial Intelligence</i></li>
                                    <li><i className='anim-text-gradient'>Machine Learning</i></li>
                                    <li><i className='anim-text-gradient'>Internet of Things</i></li>
                                    <li><i className='anim-text-gradient'>Fleet Intelligence</i></li>
                                    <li><i className='anim-text-gradient'>Internet of Things</i></li>

                                </ul>
                            </div>
                        </h3>

                    </div>
                </div>
            </div>
        </>
    )
}

export default NewFeatures;